<template>
    <Head>
        <title>Управление менеджерами</title>
    </Head>

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <div class="p-6 bg-white border border-gray-200">
            <div class="flex flex-row justify-between">
                <h3 class="font-semibold text-xl text-gray-800 sm:leading-tight">
                    Управление менеджерами
                </h3>

                <form class="flex gap-4">
                    <v-button-secondary color="green" :href="route('settings.users.create')">
                        Создать
                    </v-button-secondary>
                    <v-button type="button" color="yellow" v-if="showTrashed === false" @click="showTrashed = true">Заблокированные</v-button>
                    <v-button type="button" color="blue" v-else @click="showTrashed = false">Активные</v-button>
                </form>
            </div>
            <div class="grid gap-4 grid-cols-9 mt-6 pb-2 font-semibold">
                <div>Роль</div>
                <div class="col-span-2">Username</div>
                <div class="col-span-3">Имя</div>
                <div>Создан</div>
                <div>Изменен</div>
            </div>
            <div class="grid gap-4 grid-cols-9 border-t py-2 items-center" v-for="manager in (showTrashed ? trashed : managers)" :key="manager.id">
                <span>{{ manager.role }}</span>
                <span class="col-span-2">{{ manager.username }}</span>
                <span class="col-span-3">{{ manager.name }}</span>
                <span class="text-sm">{{ moment(manager.createdAt).format('L LTS')}}</span>
                <span class="text-sm">{{ moment(manager.updatedAt).format('L LTS')}}</span>
                <div class="flex flex-row justify-end items-center gap-4">
                    <Link
                        v-if="access('settings', 'auth_logs')"
                        :href="route('settings.manager.authorization-log', manager.id)"
                        title="Журнал авторизаций"
                        class="text-blue-700 hover:text-blue-500"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="h-4 w-4 fill-current">
                            <path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1"/>
                            <path d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117M11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5M4 1.934V15h6V1.077z"/>
                        </svg>
                    </Link>
                    <Link
                        v-if="access('settings', 'action_logs')"
                        :href="route('settings.manager.actions-log', manager.id)"
                        title="Журнал действий"
                        class="text-blue-700 hover:text-blue-500"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="h-4 w-4 fill-current">
                            <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                            <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/>
                            <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
                        </svg>
                    </Link>
                    <Link
                        :href="route('settings.users.edit', manager.id)"
                        title="Редактировать"
                        class="text-blue-700 hover:text-blue-500"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="h-4 w-4 fill-current">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    </AuthenticatedLayout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import VButton from "@/Components/Button";
import VButtonSecondary from "@/Components/ButtonSecondary";
import moment from 'moment';

export default {
    components: {
        Head,
        Link,
        AuthenticatedLayout,
        NavigationSettings,
        VButton,
        VButtonSecondary,
    },
    props: {
        managers: Object,
        trashed: Object,
        notifications: Array,
    },
    data() {
        return {
            showTrashed: false,
        }
    },
    methods: {
        moment,
    },
}
</script>
